import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import IconRoundButton from "../../CommonButtons/IconRoundButton";
import PrimaryButton from "../../CommonButtons/PrimaryButton";
import FilteredSearchField from "../../CommonSearchComponents/FilteredSearchField";
import PrimaryWithIconButton from "../../CommonButtons/PrimaryWithIconButton";
import CommonSingleandMultiView from "../../CommonSingleandMultiView";
import formatTotalBalance from "../../../../utils/formatTotalBalance";
import SecondaryAnimatedButton from "../../CommonButtons/SecondaryAnimated";
import SVGComponent from "../../SVGComponent";
import {
  GlobalConfiguration,
  ScreenSizeConfiguration,
} from "../../../../utils/configurationProvider";
import FormatAmount from "../../FormatAmount/FormatAmount";

const shouldBeRedacted = (price) => {
  return (
    price === "xxxx.xx" ||
    isNaN(+price) ||
    price === null ||
    price === undefined
  );
};
const TopNavComponentWithBalance = ({
  loading,
  topNavHeader,
  topNavSubText,
  topNavCtaBtn1Props,
  topNavCtaBtn2Props,
  filteredSearchProps,
  BottomHeader,
  BottomSubText,
  BottomSubTextVaraint,
  BottomCtaBtnProps,
  iconComponentArray,
  assignLabelProps,
  assignTagProps,
  toggleProps,
  isSelectionView,
  selectionText,
  selectionBtnProps,
  failedRefreshId,
  ownerAccBalanceLoading,
  prevBalance,
  TotalBalance,
  AllPageRefresh,
  failedMeassge,
  handleBack,
  ispagination,
  customBottomPadding,
  selectAmtType,
  BalanceStateRequired,
}) => {
  const [search, setSearch] = useState(false);
  const [mobileSearch, setMobileSearch] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isSortOpen, setIsSortOpen] = useState(false);
  const [checkBalance, SetcheckBalance] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const containerRef = useRef(null);
  const dropdownRef = useRef(null);
  const mobileDropdownRef = useRef(null);
  const mobileContainerRef = useRef(null);

  const topNavRef = useRef(null);

  const { toggle } = useSelector((state) => state.ownerAllVerification);

  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= ScreenSizeConfiguration.mobileScreen,
  );
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= ScreenSizeConfiguration.mobileScreen);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      const ref = isMobile ? mobileContainerRef : containerRef;

      if (!ref.current) return;
      if (ref.current.contains(e.target)) return;
      if (dropdownRef.current && dropdownRef.current.contains(e.target)) return;

      topNavRef?.current?.blur();

      setDropdown(false);
      setSearch(false);
      setMobileSearch(false);
      setIsFilterOpen(false);
      setIsSortOpen(false);
    };

    document.addEventListener("pointerdown", handleClickOutside);

    return () => {
      document.removeEventListener("pointerdown", handleClickOutside);
    };
  }, [isMobile]);

  useEffect(() => {
    setSearch(false);
    setMobileSearch(false);
    setIsFilterOpen(false);
    setIsSortOpen(false);
  }, [isMobile]);

  useEffect(() => {
    if (search) {
      setDropdown(false);
    }
  }, [search, toggle]);

  const getStatusIcon = () => {
    if (ownerAccBalanceLoading) {
      return "https://q2pay.in/new_assets/gifs/inputloader_white.gif";
    }

    if (failedRefreshId) {
      return "https://q2pay.in/new_assets/common/view_all/error_with_orange_circle.svg";
    }

    if (
      !ownerAccBalanceLoading &&
      prevBalance !== undefined &&
      Number(TotalBalance) !== Number(prevBalance)
    ) {
      if (Number(TotalBalance) > Number(prevBalance)) {
        return "https://q2pay.in/new_assets/gifs/arrow_up_green_gif.gif";
      } else if (Number(TotalBalance) < Number(prevBalance)) {
        return "https://q2pay.in/new_assets/gifs/arrow_down_red_gif.gif";
      }
    }

    return "";
  };

  return (
    <>
      {/* MOBILE VIEW */}
      <div
        style={{
          bottom: ispagination
            ? "var(--pagination-height)"
            : customBottomPadding
              ? `var(--${customBottomPadding})`
              : "var(--height-base)",
        }}
        className={`absolute shadow-box-shadow-top bg-primary-nav p-padding-md rounded-t-border-radius-md w-full ${topNavCtaBtn1Props || topNavCtaBtn2Props ? "flex" : "hidden"} max-w-max-content-width item-center h-auto  Qsmd:hidden z-z-index-header  gap-x-gap-sm gap-y-top_md justify-between`}
      >
        {mobileSearch && (
          <div class="absolute top-top-base left-left-base bg-PopUp-BackDrop opacity-dark-opacity pointer-events-none w-full h-full z-z-index-content Qsmd:z-z-index-header"></div>
        )}
        {topNavCtaBtn1Props ? (
          <PrimaryButton
            {...topNavCtaBtn1Props}
            fullWidthRequired={true}
          />
        ) : null}
        {topNavCtaBtn2Props ? (
          <PrimaryButton
            {...topNavCtaBtn2Props}
            fullWidthRequired={true}
          />
        ) : null}
      </div>
      <div className="bg-primary-nav w-full flex flex-col overflow-visible Qsmd:px-padding-sm px-padding-md shadow-box-shadow-bottom">
        <div className=" flex-col bg-primary-nav w-full flex  max-w-max-content-width mx-auto relative ">
          {/*WEBVIEW */}
          <div
            style={{ overflowX: "clip" }}
            className={` w-full hidden Qsmd:flex flex-wrap max-w-max-content-width item-center min-h-topnavbar-min-height h-auto relative topnav-webview  gap-gap-sm  py-padding-sm justify-start`}
          >
            <div
              className={`${topNavCtaBtn1Props || topNavHeader || topNavSubText ? "flex " : "hidden"} gap-x-gap-sm  items-center ${search ? "opacity-opacity-none" : ""} transition-all duration-animation-fast-s ease-in-out    `}
            >
              <div className={`${topNavCtaBtn1Props ? "flex" : "hidden"}`}>
                {topNavCtaBtn1Props ? (
                  <PrimaryButton {...topNavCtaBtn1Props} />
                ) : null}
              </div>

              {BalanceStateRequired && (
                <div
                  ref={dropdownRef}
                  className={`flex flex-col relative w-full ${dropdown ? "open" : ""}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (AllPageRefresh) {
                      setDropdown(!dropdown);
                    }
                  }}
                >
                  {/* ---------------------- */}
                  <div
                    className={`${AllPageRefresh ? "bg-primary-nav-act cursor-pointer" : "bg-primary-nav"} ${
                      !dropdown && AllPageRefresh && "global-hover-white"
                    } z-z-index-base relative flex items-center justify-between w-full p-padding-sm 
            ${dropdown ? "rounded-t-border-radius-sm  shadow-box-shadow-right transition-all duration-[var(--animation-fast)]" : " rounded-border-radius-sm "}`}
                  >
                    <div className="flex justify-between flex-shrink-0">
                      <div className={`flex flex-col  `}>
                        <p
                          title={`${shouldBeRedacted(TotalBalance) ? "" : "INR "} ${FormatAmount({ price: TotalBalance })}`}
                          className={` 
                       ${
                         TotalBalance < GlobalConfiguration?.lengthCheckZero &&
                         !(
                           isNaN(TotalBalance) ||
                           TotalBalance === "xxxx.xx" ||
                           TotalBalance === null ||
                           TotalBalance === undefined
                         )
                           ? "text-failed font-semibold"
                           : "text-settled font-semibold"
                       } text-font-sm font-semibold pb-padding-xs`}
                        >
                          {shouldBeRedacted(TotalBalance) ? "" : "INR "}

                          {TotalBalance !== undefined ? (
                            <>
                              {
                                formatTotalBalance(TotalBalance, selectAmtType)
                                  .amount
                              }{" "}
                              {formatTotalBalance(TotalBalance, selectAmtType)
                                .prefix !== ""
                                ? formatTotalBalance(
                                    TotalBalance,
                                    selectAmtType,
                                  ).abbr
                                : ""}
                            </>
                          ) : (
                            "00.00"
                          )}
                        </p>
                        <p className="text-text-secondary text-font-xs font-normal whitespace-nowrap">
                          {topNavSubText}
                        </p>
                      </div>

                      {AllPageRefresh ? (
                        <div className="flex justify-around relative  flex-col pl-padding-sm">
                          <img
                            className="w-icon-xs h-icon-xs   "
                            src={getStatusIcon()}
                            alt=""
                          />
                          <div
                            className={`transition-transform duration-animation-fast ease-in-out ${
                              dropdown ? "rotate-half" : "rotate-base"
                            }`}
                          >
                            <SVGComponent
                              url={
                                "https://q2pay.in/new_assets/common/arrows/arrow_down_white.svg"
                              }
                              color="var(--text-primary)"
                              width="var(--icon-xs)"
                              height="var(--icon-xs)"
                            />
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="relative">
                    <div
                      className={`bg-primary-nav-act ${dropdown ? "shadow-box-shadow-right-bottom" : ""} absolute z-z-index-dropdown overflow-hidden w-width-full rounded-b-border-radius-md`}
                      style={{
                        maxHeight: dropdown
                          ? "var(--max-animation-height-small-ddl)"
                          : "0px",
                        transition:
                          "max-height var(--animation-fast) ease-in-out ",
                      }}
                    >
                      <div
                        className="border-primary-bg border-t mx-margin-sm transition-all duration-[var(--animation-fast)]"
                        style={{
                          opacity: !dropdown
                            ? "var(--opacity-none)"
                            : "var(--base-opacity)",
                        }}
                      ></div>

                      <div
                        className={`flex flex-col pt-padding-sm pl-padding-sm pb-padding-base  ${"max-h-max-overflow-height-small-ddl-options"} bg-primary-nav-act w-full rounded-b-border-radius-md overflow-auto border-t-border-base cursor-pointer gap-gap-sm`}
                      >
                        <div className="flex flex-col pr-padding-sm bg-primary-nav-act w-full overflow-auto gap-gap-sm mb-margin-sm">
                          <div>
                            <p
                              className={`${
                                Number(prevBalance) < Number(TotalBalance)
                                  ? "text-settled"
                                  : Number(prevBalance) >
                                        Number(TotalBalance) || failedRefreshId
                                    ? "text-failed"
                                    : "text-text-primary"
                              } font-semibold text-font-sm pt-padding-xs`}
                            >
                              {failedRefreshId ? (
                                failedMeassge ||
                                "Unable to fetch balance details. Please try again later."
                              ) : (
                                <>
                                  {"INR "}

                                  {
                                    formatTotalBalance(
                                      Math.abs(prevBalance - TotalBalance),
                                      selectAmtType,
                                    ).amount
                                  }
                                </>
                              )}
                            </p>
                            <p className="text-text-secondary text-font-xs font-normal whitespace-nowrap">
                              {failedRefreshId
                                ? "Balance update"
                                : Number(TotalBalance) > Number(prevBalance)
                                  ? "Balance increased by"
                                  : Number(TotalBalance) < Number(prevBalance)
                                    ? "Balance decreased by"
                                    : "Balance"}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div
              className={`${filteredSearchProps ? "flex" : "hidden"} flex-1 ${search ? "" : "relative"} min-h-topnavheight  min-w-search-min-width`}
            >
              <div
                ref={containerRef}
                onClick={(e) => {
                  if (isFilterOpen || isSortOpen) {
                  } else {
                    setSearch((prev) => !prev);
                  }
                }}
                className={`absolute inset-left-base flex items-center justify-center
      transition-all duration-animation-fast-s ease-in-out
     ${search ? "scale-full-scale opacity-base-opacity z-z-index-overlay" : `${topNavCtaBtn1Props || topNavHeader || topNavSubText || topNavCtaBtn2Props || toggleProps ? "Qsmd:scale-x-full-scale-animate Qsmd:scale-y-full-scale  scale-full-scale" : "scale-full-scale"}   z-z-index-header`}`}
              >
                {filteredSearchProps && !isMobile && (
                  <FilteredSearchField
                    {...filteredSearchProps}
                    isTopNavSearch={search}
                    isTopNav={true}
                    setTopNavSearch={(val) =>
                      setSearch((prev) => (prev === null ? true : val))
                    }
                    setIsFilterOpen={setIsFilterOpen}
                    setIsSortOpen={setIsSortOpen}
                    topNavRef={topNavRef}
                  />
                )}
              </div>
            </div>

            <div
              className={`${iconComponentArray || assignLabelProps || assignTagProps || toggleProps || topNavCtaBtn2Props ? "flex" : "hidden"} gap-x-gap-sm items-center  ${search ? "opacity-opacity-none" : ""} transition-all duration-animation-fast-s ease-in-out  `}
            >
              {iconComponentArray?.map((item) => {
                return <IconRoundButton {...item} />;
              })}
              {assignLabelProps ? (
                <SecondaryAnimatedButton
                  {...assignLabelProps}
                  icon={"https://q2pay.in/new_assets/common/view_all/label.svg"}
                  text="Assign labels"
                />
              ) : null}
              {assignTagProps ? (
                <SecondaryAnimatedButton
                  {...assignTagProps}
                  icon={
                    "https://q2pay.in/new_assets/common/view_all/assign_tag_without_circle.svg"
                  }
                  text="Assign tags"
                />
              ) : null}
              {toggleProps ? (
                <CommonSingleandMultiView {...toggleProps} />
              ) : null}
              <div className={`${topNavCtaBtn2Props ? "flex" : "hidden"}`}>
                {topNavCtaBtn2Props ? (
                  <PrimaryButton {...topNavCtaBtn2Props} />
                ) : null}
              </div>
            </div>
          </div>

          {/*MOBILE VIEW */}

          <div
            style={{ overflowX: "clip" }}
            className={` w-full flex flex-col max-w-max-content-width item-center h-auto relative Qsmd:hidden   justify-between`}
          >
            <div
              className={`${filteredSearchProps ? "flex" : "hidden"} flex-1 relative min-h-topnavbar-min-height ${filteredSearchProps ? "pb-padding-sm" : "py-padding-sm"}   border-t-border border-primary-bg`}
            >
              <div
                ref={mobileContainerRef}
                onClick={(e) => {
                  if (isFilterOpen || isSortOpen) {
                  } else {
                    setMobileSearch((prev) => !prev);
                  }
                }}
                className={`absolute inset-top-base  flex items-center justify-center transition-all duration-animation-fast-s ease-in-out ${search ? "scale-full-scale opacity-base-opacity z-z-index-overlay" : "scale-x-full-scale-animate scale-y-full-scale"}   z-z-index-header`}
              >
                {filteredSearchProps && isMobile && (
                  <FilteredSearchField
                    {...filteredSearchProps}
                    isTopNavSearch={mobileSearch}
                    isTopNav={true}
                    setTopNavSearch={(val) =>
                      setMobileSearch((prev) => (prev === null ? true : val))
                    }
                    setIsFilterOpen={setIsFilterOpen}
                    setIsSortOpen={setIsSortOpen}
                    topNavRef={topNavRef}
                  />
                )}
              </div>
            </div>

            <div
              className={`${iconComponentArray || assignLabelProps || assignTagProps || toggleProps || BalanceStateRequired ? "flex" : "hidden"} gap-x-gap-md ${BalanceStateRequired ? " justify-between" : "justify-end"} border-t-border border-primary-bg w-full pb-padding-sm`}
            >
              <div
                className={`${iconComponentArray || assignLabelProps || assignTagProps || toggleProps || BalanceStateRequired ? "flex pt-top_sm" : "hidden"} ${BalanceStateRequired ? " justify-between" : "justify-end"} gap-x-gap-sm  w-full`}
              >
                <div
                  className={`${(topNavHeader || topNavSubText) && BalanceStateRequired ? "flex " : "hidden"} gap-x-gap-sm  items-center    `}
                >
                  {BalanceStateRequired && (
                    <div
                      ref={mobileDropdownRef}
                      className={`flex flex-col relative w-full ${dropdown ? "open" : ""}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (AllPageRefresh) {
                          setDropdown(!dropdown);
                        }
                      }}
                    >
                      {/* ---------------------- */}
                      <div
                        className={`${AllPageRefresh ? "bg-primary-nav-act cursor-pointer" : "bg-primary-nav"} ${
                          !dropdown &&
                          AllPageRefresh &&
                          "global-hover-white p-padding-sm"
                        } z-z-index-base relative flex items-center justify-between w-full  
            ${dropdown ? "p-padding-sm rounded-t-border-radius-sm  shadow-box-shadow-right transition-all duration-[var(--animation-fast)]" : " rounded-border-radius-sm "}`}
                      >
                        <div className="flex justify-between flex-shrink-0">
                          <div className={`flex flex-col  `}>
                            <p
                              title={`INR ${FormatAmount({ price: TotalBalance })}`}
                              className={`${
                                TotalBalance <
                                  GlobalConfiguration?.lengthCheckZero &&
                                !(
                                  isNaN(TotalBalance) ||
                                  TotalBalance === "xxxx.xx" ||
                                  TotalBalance === null ||
                                  TotalBalance === undefined
                                )
                                  ? "text-failed font-semibold"
                                  : "text-settled font-semibold"
                              } font-semibold text-font-sm pb-padding-xs`}
                            >
                              {shouldBeRedacted(TotalBalance) ? "" : "INR "}

                              {TotalBalance !== undefined ? (
                                <>
                                  {
                                    formatTotalBalance(
                                      TotalBalance,
                                      selectAmtType,
                                    ).amount
                                  }{" "}
                                  {formatTotalBalance(
                                    TotalBalance,
                                    selectAmtType,
                                  ).prefix !== ""
                                    ? formatTotalBalance(
                                        TotalBalance,
                                        selectAmtType,
                                      ).abbr
                                    : ""}
                                </>
                              ) : (
                                "00.00"
                              )}
                            </p>
                            <p className="text-text-secondary text-font-xs font-normal whitespace-nowrap">
                              {topNavSubText}
                            </p>
                          </div>

                          {AllPageRefresh ? (
                            <div className="flex justify-around relative  flex-col pl-padding-sm">
                              <img
                                className="w-icon-xs h-icon-xs   "
                                src={getStatusIcon()}
                                alt=""
                              />
                              <div
                                className={`transition-transform duration-animation-fast ease-in-out ${
                                  dropdown ? "rotate-half" : "rotate-base"
                                }`}
                              >
                                <SVGComponent
                                  url={
                                    "https://q2pay.in/new_assets/common/arrows/arrow_down_white.svg"
                                  }
                                  color="var(--text-primary)"
                                  width="var(--icon-xs)"
                                  height="var(--icon-xs)"
                                />
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="relative">
                        <div
                          className={`bg-primary-nav-act ${dropdown ? "shadow-box-shadow-right-bottom" : ""} absolute z-z-index-dropdown overflow-hidden w-width-full rounded-b-border-radius-md`}
                          style={{
                            maxHeight: dropdown
                              ? "var(--max-animation-height-small-ddl)"
                              : "0px",
                            transition:
                              "max-height var(--animation-fast) ease-in-out ",
                          }}
                        >
                          <div
                            className="border-primary-bg border-t mx-margin-sm transition-all duration-[var(--animation-fast)]"
                            style={{
                              opacity: !dropdown
                                ? "var(--opacity-none)"
                                : "var(--base-opacity)",
                            }}
                          ></div>

                          <div
                            className={`flex flex-col pt-padding-sm pl-padding-sm pb-padding-base  ${"max-h-max-overflow-height-small-ddl-options"} bg-primary-nav-act w-full rounded-b-border-radius-md overflow-auto border-t-border-base cursor-pointer gap-gap-sm`}
                          >
                            <div className="flex flex-col pr-padding-sm bg-primary-nav-act w-full overflow-auto gap-gap-sm mb-margin-sm">
                              <div>
                                <p
                                  className={`${
                                    Number(prevBalance) < Number(TotalBalance)
                                      ? "text-settled"
                                      : Number(prevBalance) >
                                            Number(TotalBalance) ||
                                          failedRefreshId
                                        ? "text-failed"
                                        : "text-text-primary"
                                  } font-semibold text-font-sm pt-padding-xs`}
                                >
                                  {failedRefreshId ? (
                                    failedMeassge ||
                                    "Unable to fetch balance details. Please try again later."
                                  ) : (
                                    <>
                                      {"INR "}

                                      {
                                        formatTotalBalance(
                                          Math.abs(prevBalance - TotalBalance),
                                          selectAmtType,
                                        ).amount
                                      }
                                    </>
                                  )}
                                </p>
                                <p className="text-text-secondary text-font-xs font-normal whitespace-nowrap">
                                  {failedRefreshId
                                    ? "Balance update"
                                    : Number(TotalBalance) > Number(prevBalance)
                                      ? "Balance increased by"
                                      : Number(TotalBalance) <
                                          Number(prevBalance)
                                        ? "Balance decreased by"
                                        : "Balance"}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div
                  className={`${iconComponentArray || assignLabelProps || assignTagProps || toggleProps ? "flex" : "hidden"} gap-x-gap-sm items-center  ${search ? "opacity-opacity-none" : ""} transition-all duration-animation-fast-s ease-in-out  `}
                >
                  {iconComponentArray?.map((item) => {
                    return <IconRoundButton {...item} />;
                  })}
                  {assignLabelProps ? (
                    <SecondaryAnimatedButton
                      {...assignLabelProps}
                      icon={
                        "https://q2pay.in/new_assets/common/view_all/label.svg"
                      }
                      text="Assign labels"
                    />
                  ) : null}
                  {assignTagProps ? (
                    <SecondaryAnimatedButton
                      {...assignTagProps}
                      icon={
                        "https://q2pay.in/new_assets/common/view_all/assign_tag_without_circle.svg"
                      }
                      text="Assign tags"
                    />
                  ) : null}
                  {toggleProps ? (
                    <CommonSingleandMultiView {...toggleProps} />
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          <div
            className={`flex-col Qsmd:flex-row py-padding-sm gap-y-gap-sm${BottomCtaBtnProps ? "gap-x-gap-sm" : ""} justify-between ${BottomHeader || BottomSubText || BottomCtaBtnProps ? "flex" : "hidden"}  border-t-border border-primary-bg`}
          >
            <div
              className={`flex flex-col ${BottomHeader && BottomSubText ? "gap-y-gap-xs" : ""}`}
            >
              <p
                className={`text-text-primary text-font-sm font-normal ${BottomHeader ? "flex" : "hidden"}`}
              >
                {BottomHeader}
              </p>
              <p
                className={`${BottomSubTextVaraint === "primary" ? "text-text-primary" : "text-text-secondary"} text-font-xs font-normal ${BottomSubText ? "flex" : "hidden"}`}
              >
                {BottomSubText}
              </p>
            </div>
            {BottomCtaBtnProps ? (
              <div className="py-padding-xs">
                <PrimaryWithIconButton
                  {...BottomCtaBtnProps}
                  iconToBeAlign="right"
                />
              </div>
            ) : null}
          </div>
          <div
            className={` py-padding-sm items-center  justify-between  border-t-border border-primary-bg ${isSelectionView ? "flex" : "hidden"}`}
          >
            <p className="text-text-primary text-font-xs font-normal">
              {selectionText}
            </p>
            {selectionBtnProps ? (
              <PrimaryWithIconButton
                {...selectionBtnProps}
                iconToBeAlign="right"
              />
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default TopNavComponentWithBalance;
